export function svgCSSColorOverride(color: string) {
  return `
    svg {
      & > * {
        transition-property: fill, stroke;
        transition-duration: 0.15s;
        transition-timing-function: ease-in-out;
      }

      *[fill]:not([fill='none']) {
        fill: ${color};
      }

      *[stroke]:not([stroke='none']) {
        stroke: ${color};
      }
    }`;
}
